<template>
  <div class="content-box">
    <ul class="app-view" v-if="versionUrl">
        <li>
          <img :src="anyangIcon"/>
          <!-- <p>{{ appName }}</p> -->
        </li>
        <van-button
          size="mini"
          class="down-app-btn"
          @click="downApp"
          v-if="versionUrl">
            打开APP
        </van-button>
      </ul>
    <div class="view-box news-view-box" v-if="type!==3"></div>
    <ul class="user-info">
      <li>
        <img
          :src="
            pageData.headLowPath ||
            pageData.headPath ||
            require('@/assets/img/default-header.png')
          "
          alt=""
        />
        <div>
          <p>{{ pageData.name }}</p>
          <span>{{ pageData.createTime }}</span>
        </div>
      </li>
      <div class="to-app">
        <img :src="require('@/assets/img/factShare/button.png')" alt="">
      </div>
    </ul>
    <p class="title">
      <span v-show="pageData.topicName">#{{ pageData.topicName }}</span
      >{{ factInfo }}
    </p>
    <van-row class="fact-cont" gutter="6" v-if="pageData.type == 1">
      <van-col span="8" v-for="(val, ind) in retSourceImgUrl" :key="ind">
        <img
          :src="val"
          alt=""
          class="fact-cont-img"
          @click="preview(retSourceImgUrl, ind)"
        />
      </van-col>
    </van-row>
    <div class="fact-cont" v-if="pageData.type == 2">
      <video
        controls
        autoplay
        :src="videoPath"
        class="fact-cont-video"
      ></video>
    </div>
    <!-- <a href="javascript:;" @click="openApp" class="open-app" v-if="versionUrl"></a> -->
    <van-button
      @click="openApp"
      class="open-app"
      v-if="versionUrl"
      plain
      type="danger"
      >打开{{ appName }}，看爆料更多热议</van-button
    >
    <!-- <div class="partition"></div> -->
    <div class="comments-box">
      热门评论
    </div>
    <ul class="host-list">
      <li v-for="(val, ind) in webcommentList" :key="ind">
        <img
          :src="
            val.headPath
              ? val.headPath
              : 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
          "
        />
        <ul>
          <li>
            <p>{{ val.name }}</p>
            <div v-if="versionUrl" class="list-info">
              <!-- <van-icon @click="openApp(val)" name="like" class="my-comments-like" /> -->
              <img :src="require('@/assets/img/factShare/dianzan.png')" @click="openApp(val)" />
              <span style="margin-left:5px;">{{ val.likeCount || 0 }}</span>
            </div>
          </li>
          <li>{{ val.info }}</li>
          <li>
            <span>{{ initTime(val.time,3) }}</span>
            <div v-if="versionUrl" @click="openApp(val)">回复</div>
          </li>
        </ul>
      </li>
    </ul>
    <div v-if="versionUrl" class="my-comments" @click="openApp">
      <p>发表你的观点</p>
      <div>
        <img :src="require('@/assets/img/factShare/pinglun.png')" />
        <img :src="require('@/assets/img/factShare/dianzan.png')" />
        <img :src="require('@/assets/img/factShare/fenxiang.png')" />
      </div>
    </div>
  </div>
</template>

<script>
//地址  访问地址+/factShare?id=797368996706215838&bundleID=
import * as sctipts from "../service/share";
import share from "../utils/share";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      title: "",
      author: "",
      source: "",
      createTime: "",
      fullWord: "",
      webcommentList: [],
      type: "0",
      versionUrl: "",
      path: "",
      appName: "",
      appIcon: '',
      anyangIcon: require('../assets/img/logo.png'),
      shareIcon: require('../assets/img/shareLogo.png'),
      OpenUrl: "",
      type: 0,
      pageData: {},
      videoPath: "",
    };
  },
  mounted() {
    if (this.equipmentType() == "iOS") {
      this.type = 0;
    } else if (this.equipmentType() == "Android") {
      this.type = 1;
    } else {
      this.type = 3;
    }
    if (this.$route.query.id) {
      sctipts
        .getFact(this.$route.query.id)
        .then(({ data }) => {
          if (data.status == 0) {
            if (data.data) {
              this.pageData = data.data;
              this.pageData.createTime = sctipts.initTime(data.data.time);
              this.showVideoView();
              document.title = this.title;
              let obj={
                title: data.data.title,
                desc: data.data.news,
                link: location.href,
                img: this.appIcon,
              }
              let url = process.env.NODE_ENV === 'production' ? window.location.href : process.env.VUE_APP_URL+this.$route.fullPath;
              share.getJSSDK(url.split('#')[0],obj)
            }
          } else {
            alert(data.desc);
          }
        })
        .catch((res) => {
          console.log("连接服务器错误");
        });
      sctipts
        .getComment(this.$route.query.id)
        .then(({ data }) => {
          if (data.status == 0) {
            if (data.data) {
              this.webcommentList = data.data;
            }
          } else {
            alert(data.desc);
            console.log(data.desc);
          }
        })
        .catch((res) => {
          console.log("连接服务器错误");
        });
      sctipts
        .getAppUrl({ type: this.type, bundleID: this.$route.query.bundleID })
        .then(({ data }) => {
          if (data.status == 0) {
            // this.webcommentList = data.data;
            if (data.data) {
              this.versionUrl = data.data.versionUrl;
              this.appName = data.data.applicationName;
              this.appIcon = data.data.applicationHeadPath;
              this.appScheme = data.data.applicationUrlScheme
            }
          } else {
            console.log(data.desc);
          }
        });
    } else {
      console.log("未获取id");
    }
  },
  computed: {
    retSourceImgUrl() {
      if (this.pageData.pathLowList) {
        if (this.pageData.pathLowList.length > 0) {
          return this.pageData.pathLowList;
        } else if (this.pageData.pathList) {
          if (this.pageData.pathList.length > 0) {
            return this.pageData.pathList;
          } else {
            return [];
          }
        } else {
          return [];
        }
      } else if (this.pageData.pathList) {
        if (this.pageData.pathList.length > 0) {
          return this.pageData.pathList;
        } else {
          return [];
        }
      } else {
        return [];
      }
    },
    factInfo() {
      if (this.pageData.topicId) {
        return this.pageData.info.replace(`#${this.pageData.topicName}`, "");
      } else {
        return this.pageData.info;
      }
    },
  },
  methods: {
    equipmentType() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return "Android";
      } else if (isiOS) {
        return "iOS";
      } else {
        return "noMobileDevices";
      }
    },
    initTime(time,type) {
      return sctipts.initTime(time,type);
    },
    // downApp() {
    //   let u = navigator.userAgent;
    //   let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    //   let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //   if (isAndroid) {
    //     let ua = navigator.userAgent.toLowerCase();
    //     let isWeixin = ua.indexOf("micromessenger") != -1;
    //     if (isWeixin) {
    //       alert("请点击右上方选择浏览器打开本页面下载app");
    //     } else {
    //       window.location.href = this.versionUrl;
    //     }
    //   } else if (isiOS) {
    //     window.location.href = this.versionUrl;
    //   } else {
    //     alert("请使用手机打开本页面。");
    //   }
    // },
    openApp (item) {
      // 1文章,2 视频, 3  电视直播, 4 活动直播, 5 栏目详情, 6 图片详情, 7 爆料详情
      var link=''
        if (item.releaseSourceId) {
          link = `${this.appScheme}://${this.$getModules(7)}?sourceId=${item.releaseSourceId}`;
        }else{
          link = `${this.appScheme}://${this.$getModules(7)}?sourceId=${this.$route.query.id}`;
        }
      var downUrl = location.origin+'/invitation?type='+this.$route.query.type+'&bundleID='+this.$route.query.bundleID;
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          var loadDateTime = new Date();
          window.setTimeout(function() {
              var timeOutDateTime = new Date();
              if (timeOutDateTime - loadDateTime < 5000) {
                //下载分享页
                window.location = downUrl;
              } else {
                window.close();
              }
          },500);
          window.location = link;
        }
      } else if (navigator.userAgent.match(/android/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          window.location.href = link;
          window.setTimeout(() => {
            //下载分享页
            window.location = downUrl
          }, 2500);
        }
      }
    },
    downApp (item) {
      // 1文章,2 视频, 3  电视直播, 4 活动直播, 5 栏目详情, 6 图片详情, 7 爆料详情
      var link=''
        if (item.releaseSourceId) {
          link = `${this.appScheme}://${this.$getModules(7)}?sourceId=${item.releaseSourceId}`;
        }else{
          link = `${this.appScheme}://${this.$getModules(7)}?sourceId=${this.$route.query.id}`;
        }
      var downUrl = location.origin+'/invitation?type='+this.$route.query.type+'&bundleID='+this.$route.query.bundleID;
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          var loadDateTime = new Date();
          window.setTimeout(function() {
              var timeOutDateTime = new Date();
              if (timeOutDateTime - loadDateTime < 5000) {
                //下载分享页
                window.location = downUrl;
              } else {
                window.close();
              }
          },500);
          window.location = link;
        }
      } else if (navigator.userAgent.match(/android/i)) {
        if (isWeixin) {
          alert("请点击右上方选择浏览器打开本页面");
        } else {
          window.location.href = link;
          window.setTimeout(() => {
            //下载分享页
            window.location = downUrl
          }, 2500);
        }
      }
    },
    preview(url, ind) {
      ImagePreview({
        images: url,
        startPosition: ind,
        closeable: true,
      });
    },

    showVideoView() {
      if (this.pageData.pathLowList) {
        if (this.pageData.pathLowList.length > 0) {
          this.videoPath = this.pageData.pathLowList[0];
        } else if (this.pageData.pathList) {
          if (this.pageData.pathList.length > 0) {
            this.videoPath = this.pageData.pathList[0];
          } else {
            this.videoPath = "";
          }
        } else {
          this.videoPath = "";
        }
      } else if (this.pageData.pathList) {
        if (this.pageData.pathList.length > 0) {
          this.videoPath = this.pageData.pathList[0];
        } else {
          this.videoPath = "";
        }
      } else {
        this.videoPath = "";
      }
    },
  },
};
</script>

<style scoped>
.content-box {
  min-height: 100%;
  position: relative;
  overflow: hidden;
}
.blue-title {
  height: 20px;
  line-height: 20px;
  padding-left: 5px;
  color: #333;
  font-weight: bold;
  font-size: 16px;
  position: relative;
  margin-bottom: 14px;
  margin: 0;
}
.open-app {
  width: calc(100% - 30px);
  display: block;
  height: 40px;
  color: #be1928;
  border-color: #be1928;
  border-radius: 5px;
  margin: 15px auto;
}
.partition {
  height: 5px;
  background-color: #f3f3f3;
  margin-bottom: 20px;
}
.host-list {
  width: calc(100% - 30px);
  height: calc(100% - 400px);
  margin: 0 auto 50px;
  position: relative;
  overflow-y: auto;
}
.host-list > li {
  overflow: hidden;
  margin-bottom: 20px;
}
.host-list > li > img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #fff;
  float: left;
  overflow: hidden;
}
.host-list > li > ul {
  width: calc(100% - 45px);
  float: right;
  overflow: hidden;
}
.host-list > li > ul > li:nth-child(1) {
  height: 20px;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
}
.host-list > li > ul > li:nth-child(1) > p {
  font-size: 14px;
  color: #333333;
  max-width: 70%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.host-list > li > ul > li:nth-child(1) > div {
  font-size: 12px;
  color: #d1d3d8;
  display: flex;
  align-items: center;
}
.host-list > li > ul > li:nth-child(2) {
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}
.host-list > li > ul > li:nth-child(3) {
  color: #8a8a8a;
  font-size: 12px;
  display: flex;
  align-items: center;
}
.host-list > li > ul > li:nth-child(3) > div {
  width: 40px;
  height: 18px;
  background-color: #eeeff2;
  color: #333333;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  border-radius: 9px;
  margin-left: 10px;
}
.app-view .down-app-btn {
  width: 81px;
  height: 32px;
  border-radius: 5px;
  font-size: 14px;
  border: 1px solid #be1928;
  background-color: #be1928;
  color: #fff;
}
.app-view {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 13px;
  box-sizing: border-box;
  position: fixed;
  background-color: #fff;
  margin:auto;left:0; right:0; top:0;
  z-index: 2000;
}

.app-view > li:nth-child(1) {
  height: 44px;
}

.app-view > li:nth-child(1) > img {
  height: 44px;
  display: block;
  float: left;
}

.app-view > li:nth-child(1) > p {
  font-size: 14px;
  color: #333333;
  float: left;
  margin-left: 8px;
  line-height: 44px;
}

.app-view > li:nth-child(2) {
  height: 44px;
  overflow: hidden;
}

.app-view > li:nth-child(2) > a {
  display: block;
  width: 81px;
  height: 26px;
  background-color: #518dfa;
  border: none;
  color: #fff;
  font-size: 14px;
  outline: none;
  text-align: center;
  line-height: 26px;
  text-decoration: none;
  border-radius: 5px;
}
.comments-box{
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  line-height: 17px;
  padding: 0 20px;
  margin-top: 40px;
}
.my-comments {
  width: 100%;
  height: 50px;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  box-shadow: 0px 3px 8px 0px rgba(173, 182, 199, 1);
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.my-comments > p {
  height: 36px;
  width: 222px;
  color: #8e8e8e;
  font-size: 13px;
  line-height: 33px;
  background-color: #f7f7f7;
  padding-left: 20px;
  box-sizing: border-box;
  border-radius: 20px;
}
.my-comments > div {
  font-size: 12px;
  color: #be1928;
  display: flex;
  align-items: center;
  height: 36px;
}
.my-comments > div img{
  margin-left: 25px;
}
.my-comments-like {
  font-size: 18px;
}
.user-info {
  margin-top: 12px;
  margin-bottom: 20px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user-info > li {
  height: 60px;
  display: flex;
}
.user-info > li:nth-child(1) > img {
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 10px;
}
.user-info > li:nth-child(1) > div {
  height: 60px;
}
.user-info > li:nth-child(1) > div > p {
  font-size: 16px;
  color: #333;
  height: 30px;
  line-height: 30px;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.user-info > li:nth-child(1) > div > span {
  color: #999;
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  display: block;
}
.user-info .to-app {
  width: 60px;
  height: 32px;
}
.user-info .to-app img{
  display: block;
  width: 100%;
  height: 100%;
}
.title {
  max-height: 50px;
  font-weight: bold;
  color: #333;
  font-weight: 700;
  font-size: 16px;
  font-family: SourceHan;
  line-height: 1.3;
  letter-spacing: 0;
  text-align: left;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  padding: 0 20px;
}
.title > span {
  margin-right: 5px;
}
.fact-cont {
  width: calc(100% - 30px);
  margin: 15px auto;
}
.fact-cont-img {
  display: block;
  width: 107px;
  height: 72px;
  border-radius: 4px;
  object-fit: cover;
  margin-bottom: 6px;
}
.fact-cont-video {
  width: 100%;
  height: 200px;
  background-color: #000;
}
.list-info img{
  width: 12px;
  height: 12px;
  display: block;
}
</style>